import moment from 'moment-timezone';

export function dateToMoment(date, dateFormat) {
  const formats = [dateFormat, moment.ISO_8601, 'DD/MM/YYYY', 'DD.MM.YYYY', 'DD-MM-YYYY',
    'YYYY-MM-DD', 'YYYY.MM.DD', 'YYYY/MM/DD', 'MM/DD/YYYY', 'MM-DD-YYYY', 'MM.DD.YYYY'];
  if (date && moment.isMoment(date)) {
    return date;
  } else if (date && moment.isDate(date)) {
    return moment.utc(date);
  } else if (date && (typeof date === 'string' || date instanceof String) && moment(date, formats, true).isValid()) {
    return moment.utc(date);
  }
  return null;
}

export function isSameDay (moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, 'day');
  }
  return !moment1 && !moment2;
}

export function isSameTime (moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, 'second');
  }
  return !moment1 && !moment2;
}

export function isSame(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2);
  }
  return !moment1 && !moment2;
}

export function isDayDisabled (day, { minDate, maxDate, excluded, included, filtered } = {}) {
  return (minDate && day.isBefore(minDate, 'day')) ||
    (maxDate && day.isAfter(maxDate, 'day')) ||
    (excluded && excluded.some(excludeDate => isSameDay(day, excludeDate))) ||
    (included && !included.some(includeDate => isSameDay(day, includeDate))) ||
    (filtered && !filtered(day.clone())) ||
    false;
}

export function allDaysDisabledBefore (day, unit, { minDate, included } = {}) {
  const dateBefore = day.clone().subtract(1, unit);
  return (minDate && dateBefore.isBefore(minDate, unit)) ||
    (included && included.every(includeDate => dateBefore.isBefore(includeDate, unit))) ||
    false;
}

export function allDaysDisabledAfter (day, unit, { maxDate, included } = {}) {
  const dateAfter = day.clone().add(1, unit);
  return (maxDate && dateAfter.isAfter(maxDate, unit)) ||
    (included && included.every(includeDate => dateAfter.isAfter(includeDate, unit))) ||
    false;
}

export function getEffectiveMinDate ({ minDate, included }) {
  if (included && minDate) {
    return moment.min(included.filter(includeDate => minDate.isSameOrBefore(includeDate, 'day')));
  } else if (included) {
    return moment.min(included);
  }
  return minDate;
}

export function getEffectiveMaxDate ({ maxDate, included }) {
  if (included && maxDate) {
    return moment.max(included.filter(includeDate => maxDate.isSameOrAfter(includeDate, 'day')));
  } else if (included) {
    return moment.max(included);
  }
  return maxDate;
}

export function isInSameRangeClock(selected, value) {
  if ((selected > 0 && selected <= 12) && (value > 0 && value <= 12)) {
    return true;
  } else if ((selected === 0 || (selected > 12 && selected <= 23)) && (value === 0 || (value > 12 && value <= 23))) {
    return true;
  }
  return false;
}

export function timezoneToOffset(timezone) {
  if (timezone) {
    try {
      if (isNaN(parseFloat(timezone))) {
        return moment.tz(timezone).utcOffset();
      }
      return parseFloat(timezone);
    } catch (e) {
      return 0;
    }
  }
  return 0;
}

export const convertToMomentObject = date => {
  if (date && !moment.isMoment(date)) {
    return moment(date);
  }
  return date;
}
